import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import Modal from 'react-awesome-modal'
import Rater from 'react-rater'
import { connect } from 'react-redux'

class ModalEvaluation extends Component {
  constructor () {
    super()
    this.state = {
      stepOne: true,
      stepTwo: false,
      stepDone: false,
      stepError: false,
      modalTitle: 'quantas estrelas este parceiro merece?',
      titleError: 'Encontramos um problema ao salvar seu comentário.',
      rating: 0,
      emptyRating: false,
      emptyTitle: false,
      emptyComment: false,
      evaluateTitle: null,
      evaluateComment: null,
      buttonDisabled: false
    }
  }
  goToStepOne = () => {
    this.setState({
      stepOne: true,
      stepTwo: false,
      stepDone: false,
      stepError: false,
      modalTitle: 'quantas estrelas este parceiro merece?',
      titleError: 'Encontramos um problema ao salvar seu comentário.',
      rating: 0,
      emptyRating: false,
      evaluateTitle: '',
      evaluateComment: ''
    })
  }
  goRate = () => {
    this.setState({ stepOne: true, stepTwo: true, modalTitle: 'quantas estrelas este parceiro merece?' })
  }
  onRating = (e) => {
    this.setState({ rating: e && e.rating, emptyRating: false })
    this.goRate()
  }
  onSend = () => {
    this.setState({ buttonDisabled: true })

    if (this.state.rating === 0) {
      this.setState({ emptyRating: true, buttonDisabled: false })
      return false
    }
    if (!this.state.evaluateTitle) {
      this.setState({ emptyTitle: true, buttonDisabled: false })
      return false
    }
    if (!this.state.evaluateComment) {
      this.setState({ emptyComment: true, buttonDisabled: false })
      return false
    }

    this.props.createEvaluate(this.state.evaluateTitle, this.state.evaluateComment, this.state.rating, this.props.userId && this.props.userId.value, this.props.name && this.props.name.value).then(result => {
      if (result.data.message === 'Avaliação salva com sucesso.') {
        this.setState({ stepOne: false, stepTwo: false, stepDone: true, modalTitle: 'Obrigado por avaliar :)', buttonDisabled: false })
      } else if (result.data.message === 'Avaliação já realizada') {
        this.setState({ stepOne: false, stepTwo: false, stepDone: true, stepError: true, modalTitle: 'Avaliação já realizada', buttonDisabled: false, titleError: 'Avaliação já registrada pelo participante para essa rede.' })
      } else {
        this.setState({ stepOne: false, stepTwo: false, stepDone: true, stepError: true, modalTitle: 'OPS :(', buttonDisabled: false, titleError: 'Encontramos um problema ao salvar seu comentário.' })
      }
    })
  }
  onClose = () => {
    this.setState({
      stepOne: true,
      stepTwo: false,
      stepDone: false,
      stepError: false,
      modalTitle: 'quantas estrelas este parceiro merece?',
      rating: 0,
      emptyRating: false,
      evaluateTitle: null,
      evaluateComment: null
    })
    this.props.onClose()
  }
  stateOpinion (e) {
    let value = e.target ? String(e.target.value) : null
    if (value) {
      this.setState({ emptyTitle: false })
    }
    this.setState({ evaluateTitle: value })
  }
  stateComment (e) {
    let value = e.target ? String(e.target.value) : null
    if (value) {
      this.setState({ emptyComment: false })
    }
    this.setState({ evaluateComment: value })
  }
  render () {
    return (
      <div className=' modal-marker'>
        <Modal
          width='100%'
          height='100%'
          effect='fadeInUp'
          visible={(this.props.show)}
        >
          <div className='container h-100'>
            <div className='row align-items-md-center h-100'>
              <div className='modal-rating col-auto mx-auto bg-white radius '>
                <div className='row'>
                  <div className='col-12 py-2 px-2 border-bottom border-color-ui-3'>
                    <h2 className='py-half'>{this.state.modalTitle}</h2>
                  </div>
                </div>
                <div className='row'>
                  <div className='modal-scroll col-12 py-3'>
                    <div className='row mx--1 mx-md-1'>
                      <div id='stepOne' className={`col-12 color-ui-2 txt-font-body txt-body-sm product-rating ${!this.state.stepDone ? '' : 'd-none'}`}>
                        <div className='row mx-0'>
                          <p className='col-12 txt-body-sm pb-2'>Que avaliação este produto merece?</p>
                          <div className={`col-12 store-rating modal-rating-stars mx-0 ${this.state.emptyRating && 'rating-empty'}`}>
                            <Rater id='rater-modal-products' total={5} rating={this.state.rating} onRate={(e) => this.onRating(e)} />
                          </div>
                          {this.state.emptyRating &&
                          <div className='col-12 mt-1'>
                            <p className='color-error txt-subtitle'>escolha uma avaliação para enviar</p>
                          </div>
                          }
                        </div>
                      </div>
                      <div id='stepTwo' className={`col-12 color-ui-2 txt-font-body txt-body-sm product-rating mt-2   ${!this.state.stepTwo && 'd-none'}`}>
                        <div className='row'>
                          <div className='col-12 mb-2'>
                            <p className='txt-body-sm'>Escreva um comentário sobre a sua experiência com este produto.</p>
                          </div>
                          <Input
                            id='txt-opinion'
                            name='txt-opinion'
                            label='Título da sua opinião'
                            className='form-field col-12 mb-2'
                            childrenClassName='has-content'
                            onBlur={(e) => this.stateOpinion(e)}
                            data-error={'Por favor, preencher o título.'}
                            valid={!this.state.emptyTitle ? null : false}
                          />
                          <Input
                            id='txt-comment'
                            name='txt-comment'
                            label='Deixe um comentário'
                            className='form-field col-12'
                            childrenClassName='has-content'
                            onBlur={(e) => this.stateComment(e)}
                            data-error={'Por favor, deixe um comentário.'}
                            valid={!this.state.emgptyComment ? null : false}
                          />
                        </div>
                      </div>
                      <div id='stepFinal' className={`col-12 color-ui-2 txt-font-body txt-body-sm product-rating mt-2 ${!this.state.stepDone ? '' : 'd-none'}`}>
                        <div className='row'>
                          <div className='col-12'>
                            <p className='txt-body-sm pb-1 px-0'>
                              {!this.state.stepError ? 'Sua opinião é muito importante para nós, pois ela ajuda a melhorar sua experiência no Premmiar.' : this.state.titleError }
                            </p>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-12 col-md-6 my-half'>
                            <Button
                              id={'btn-back-rating'}
                              name={'btn-back-rating'}
                              className='btn btn-rating-modal col-12'
                              text='cancelar'
                              onClick={this.onClose}
                              disabled={this.state.buttonDisabled}
                            />
                          </div>
                          <div className='col-12 col-md-6 my-half ml-auto'>
                            {!this.state.buttonDisabled
                              ? <Button
                                id={'btn-close-modal'}
                                name={'btn-close-modal'}
                                className='btn btn-featured btn-rating-modal2 col-12'
                                text='enviar'
                                onClick={this.onSend}
                                disabled={this.state.buttonDisabled}
                              /> : '' }
                          </div>
                        </div>
                      </div>
                      <div id='stepDone' className={`col-12 modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0 mt-2 ${this.state.stepDone || 'd-none'}`}>
                        <div className='row'>
                          <div className='col-12'>
                            {!this.state.stepError ? 'Sua opinião é muito importante para nós, pois ela ajuda a melhorar sua experiência no Premmiar.' : this.state.titleError }
                          </div>
                          <div className='col-12 col-md-6 my-half'>
                            <Button
                              id={'btn-back-rating'}
                              name={'btn-back-rating'}
                              className='btn btn-rating-modal col-12'
                              text='deixar outro comentário'
                              onClick={this.goToStepOne}
                              disabled={this.state.buttonDisabled}
                            />
                          </div>
                          <div className='col-12 col-md-6 my-half ml-auto'>
                            <Button
                              id={'btn-close-modal'}
                              name={'btn-close-modal'}
                              className='btn btn-featured btn-rating-modal2 col-12'
                              text='concluir'
                              onClick={this.onClose}
                              disabled={this.state.buttonDisabled}
                            />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

ModalEvaluation.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.bool,
  createEvaluate: PropTypes.func,
  name: PropTypes.string,
  userId: PropTypes.string
}

const mapStateToProps = ({ participant }, ownProps) => {
  return ({
    name: participant.name,
    userId: participant.cpf
  })
}

export default connect(
  mapStateToProps,
  null
)(ModalEvaluation)



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Product/ModalEvaluation/ModalEvaluation.js